$(document).on('turbolinks:load', function() {
  $('.fundraising-pitch-page').on('click', '.donation-amounts a', function(e) {
    e.preventDefault();
    if($(this).hasClass('selected')) return false;
    $('.donation-amounts a').removeClass('selected');
    $(this).addClass('selected');
    if($(this).hasClass('other-amount')) {
      $('#amount-hidden').prop('disabled', true);
      $('.amount-field').show();
      $('.amount-field input').prop('disabled', false).trigger('input');
      $('.amount-field').find('.mdc-text-field').removeClass('mdc-text-field--disabled');
    } else {
      $('#amount-hidden').prop('disabled', false).val($(this).data('amount')).trigger('change');
      $('.amount-field').hide();
      $('.amount-field input').prop('disabled', true);
    }
  });

  $('.fundraising-pitch-page').on('change', '#create_account', function() {
    if($(this).is(':checked')) {
      $('.user-fields').show();
      $('.user-fields input').prop('disabled', false)
      $('.user-fields').find('.mdc-text-field').removeClass('mdc-text-field--disabled');
    } else {
      $('.user-fields').hide();
      $('.user-fields input').prop('disabled', true);
    }
  });

  $('.fundraising-pitch-page').on('change', '#customize_display', function() {
    if($(this).is(':checked')) {
      $('.display-fields').show();
      $('.display-fields input').prop('disabled', false);
      $('.display-fields').find('.mdc-text-field').removeClass('mdc-text-field--disabled');
    } else {
      $('.display-fields').hide();
      $('.display-fields input').prop('disabled', true)
      $('.display-fields').find('.mdc-text-field').addClass('mdc-text-field--disabled');
    }
  });

  $('.fundraising-pitch-page').on('change', '#use_saved_payment', function() {
    if($(this).is(':checked')) {
      $('.payment-fields').hide();
      $('.payment-fields input').prop('disabled', true)
      $('.payment-fields').find('.mdc-text-field').addClass('mdc-text-field--disabled');
    } else {
      $('.payment-fields').show();
      $('.payment-fields input').prop('disabled', false);
      $('.payment-fields').find('.mdc-text-field').removeClass('mdc-text-field--disabled');
    }
  });

  $('.fundraising-pitch-page #use_saved_payment').trigger('change');
});